import {
  STRIPE_PAYMENT_DECLINED_DISMISS_TRY_ANOTHER_CARD_ERROR_CODES,
  STRIPE_PAYMENT_DECLINED_MODAL_ERROR_CODES,
  STRIPE_RETRYABLE_PAYMENT_ERROR_CODES,
  STRIPE_TRY_ANOTHER_CARD_PAYMENT_ERROR_CODES,
} from '@features/Stripe/constants';

const stripeRetryablePaymentErrorCodeSet = new Set<string>(
  STRIPE_RETRYABLE_PAYMENT_ERROR_CODES,
);

const stripeTryAnotherCardPaymentErrorCodeSet = new Set<string>(
  STRIPE_TRY_ANOTHER_CARD_PAYMENT_ERROR_CODES,
);

const stripePaymentDeclinedModalErrorCodeSet = new Set<string>(
  STRIPE_PAYMENT_DECLINED_MODAL_ERROR_CODES,
);

const stripePaymentDeclinedDismissTryAnotherCardErrorCodeSet = new Set<string>(
  STRIPE_PAYMENT_DECLINED_DISMISS_TRY_ANOTHER_CARD_ERROR_CODES,
);

type TpStripePaymentErrorCodeFields = {
  code?: string | null;
  decline_code?: string | null;
};

type TpStripePaymentIntentLike = {
  last_payment_error?: TpStripePaymentErrorCodeFields | null;
};

type TpStripePaymentErrorLike = TpStripePaymentErrorCodeFields & {
  payment_intent?: TpStripePaymentIntentLike | null;
};

export const getStripePaymentErrorCodes = ({
  error,
  paymentIntent,
}: {
  error?: TpStripePaymentErrorLike | null;
  paymentIntent?: TpStripePaymentIntentLike | null;
}) =>
  [
    error?.decline_code,
    error?.code,
    error?.payment_intent?.last_payment_error?.decline_code,
    error?.payment_intent?.last_payment_error?.code,
    paymentIntent?.last_payment_error?.decline_code,
    paymentIntent?.last_payment_error?.code,
  ].filter((code): code is string => typeof code === 'string');

export const getStripeRetryablePaymentErrorCode = ({
  error,
  paymentIntent,
}: {
  error?: TpStripePaymentErrorLike | null;
  paymentIntent?: TpStripePaymentIntentLike | null;
}) =>
  getStripePaymentErrorCodes({ error, paymentIntent }).find((code) =>
    stripeRetryablePaymentErrorCodeSet.has(code),
  );

export const isStripeTryAnotherCardPaymentError = ({
  error,
  paymentIntent,
}: {
  error?: TpStripePaymentErrorLike | null;
  paymentIntent?: TpStripePaymentIntentLike | null;
}) =>
  getStripePaymentErrorCodes({ error, paymentIntent }).some((code) =>
    stripeTryAnotherCardPaymentErrorCodeSet.has(code),
  );

export const isStripePaymentDeclinedModalError = ({
  error,
  paymentIntent,
}: {
  error?: TpStripePaymentErrorLike | null;
  paymentIntent?: TpStripePaymentIntentLike | null;
}) =>
  getStripePaymentErrorCodes({ error, paymentIntent }).some((code) =>
    stripePaymentDeclinedModalErrorCodeSet.has(code),
  );

export const isStripePaymentDeclinedDismissTryAnotherCardError = ({
  error,
  paymentIntent,
}: {
  error?: TpStripePaymentErrorLike | null;
  paymentIntent?: TpStripePaymentIntentLike | null;
}) =>
  getStripePaymentErrorCodes({ error, paymentIntent }).some((code) =>
    stripePaymentDeclinedDismissTryAnotherCardErrorCodeSet.has(code),
  );
